var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgHome = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.693 3.60532C13.8736 3.46489 14.1264 3.46489 14.307 3.60532L23.307 10.6053C23.4288 10.7001 23.5 10.8457 23.5 11V22C23.5 22.663 23.2366 23.2989 22.7678 23.7678C22.2989 24.2366 21.663 24.5 21 24.5H7C6.33696 24.5 5.70107 24.2366 5.23223 23.7678C4.76339 23.2989 4.5 22.663 4.5 22V11C4.5 10.8457 4.57124 10.7001 4.69303 10.6053L13.693 3.60532ZM11.5 23.5H16.5V14.5H11.5V23.5ZM17.5 23.5V14C17.5 13.7239 17.2761 13.5 17 13.5H11C10.7239 13.5 10.5 13.7239 10.5 14V23.5H7C6.60218 23.5 6.22064 23.342 5.93934 23.0607C5.65804 22.7794 5.5 22.3978 5.5 22V11.2445L14 4.63343L22.5 11.2445V22C22.5 22.3978 22.342 22.7794 22.0607 23.0607C21.7794 23.342 21.3978 23.5 21 23.5H17.5Z",
    fill: "#111111"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHome, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/home.f07a444d.svg";
export { ForwardRef as ReactComponent };